export default "__VITE_ASSET__DdHujXNs__"